// packages
import { computed } from '@vue/composition-api';

// utils
import { firstLastWords } from '@/utils/';

/**
 *
 * De forma a evitar uma nova interação do array da listagem para que
 * se consiga obter os valores que estão mais abaixo da árvore do objecto, então
 * foi feito uma listagem base, por página, com esses valores, de forma a aproveitar
 * a interação que reproduz a estrutura HTML da página.
 *
 * É feito a validação se o header que irá aparecer no card, é deep:
 *     Caso seja, é verificado a key pai, e é enviado o valor.
 *     Caso não seja, é enviado o valor desse header.
 *
 * @since 1.0.0
 * @category Hook
 * @returns {String}
 *
 */
const getValue = ( header, row, route ) => {
    // definição dos headers em que é necessário ir
    // mais fundo na árvore do objecto.
    const deepStructure = [ {
        routes: [ 'client', 'users' ],
        fields: [ {
            header: 'role',
            key: 'id',
            callback: 'inverse'
        } ]
    }, {
        routes: [ 'clients', 'client', 'users', 'campaigns', 'audit' ],
        fields: [ {
            header: 'id',
            key: 'state'
        } ]
    }, {
        routes: [ 'campaigns', 'client' ],
        fields: [ {
            header: 'type',
            key: 'name',
            callback: 'inverse'
        } ]
    }, {
        routes: [ 'audit' ],
        fields: [ {
            header: 'taxpayerIdentificationNumber',
            key: 'person'
        }, {
            header: 'name',
            key: 'person',
            utils: true
        } ]
    } ];

    // Callbacks
    // construção da estrutura da obtenção
    // do valor proveniente da API.
    // alguns valores é necessário que a ordem das keys
    // seja inversa.
    const callbacks = {
        inverse: ( value, customKey, key ) => value[key][customKey],
        default: ( value, customKey, key ) => value[customKey][key]
    };

    // obtenção do valor.
    // Valida se não é necessário ir ao fundo do objecto, caso não seja
    // é enviado o valor do header default. Caso seja, vai buscar o valor
    // a key pai do header.
    const value = computed( () => {
        // obtenção das deepkeys.
        const deepKeys = deepStructure
            .filter( ({ routes }) => routes.includes( route.name ) )
            .reduce( ( array, obj ) => ( [ ...array, ...obj.fields ] ), [] );

        if ( !deepKeys.length )
            return row[header];

        const parent = deepKeys.find( deep => deep.header === header );

        if ( !parent || !row[parent.key] )
            return row[header];

        // validação se o valor necessita de utils
        if ( parent.utils )
            return firstLastWords( row[parent.key][header] );

        const callback = parent.callback || 'default';
        return callbacks[callback]( row, parent.key, header );
    });

    return { value };
};

export default getValue;